import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateService } from '../../services/translation/translate.service';
import { AppPipes } from '../../pipes';
import { NotificationService } from '../../services/notification/notification.service';
import { SharedService } from '../../services/shared-service/shared.service';
import { WINDOW } from '../../services/window/window.service';
import { NavbarItem } from 'src/app/types';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: [
        './footer.component.less',
        './footer.component-desktop-medium.less',
        './footer.component-desktop-small.less',
        './footer.component-tablet.less',
        './footer.component-phone-big.less',
        './footer.component-phone-small.less',
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        AngularSvgIconModule,
        AppPipes,
    ]
})
export class FooterComponent implements OnInit, AfterViewInit {
  @Input() clientObject: any;
  public footerNavbarItems!: NavbarItem[];
  selectedLanguage = this.translate.language;
  locationObject: any = '';
  /* temp any; will be overriden soon */
  locations: any = [];
  constructor(
    @Inject(WINDOW) public window: Window,
    private router: Router,
    private translate: TranslateService,
    private sharedService: SharedService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.selectedLanguage = this.translate.language;
    this.footerNavbarItems = structuredClone(this.clientObject?.listOfNavbarItems?.filter((i: NavbarItem) => i.footerOrderNumber) || []).sort((a:NavbarItem, b:NavbarItem) => {
      return a.footerOrderNumber - b.footerOrderNumber;
    });;
  }

  ngAfterViewInit(): void {
    this.locations = this.clientObject?.contactUs?.map((i:any) => {
      return this.sharedService.parseLocationObject(i.location);
    })
    this.cdr.detectChanges();
  }

  goToHomePage() {
    this.router.navigate([`${this.selectedLanguage}/home`]).then();
    if (this.sharedService.isBrowser()) {
      this.window.scrollTo(0, 0);
    }
  }

  scrollUp() {
    if (this.sharedService.isBrowser()) {
      this.window.scrollTo(0, 0);
    }
  }

  showSocial() {
    return this.clientObject?.social?.facebook || this.clientObject?.social?.instagram || this.clientObject?.social?.whatsApp;
  }

  getItemFilterColor() {
    switch (this.clientObject.clientTheme) {
      case 'light':
        return 'row-icon-light';
      case 'dark':
        return 'row-icon-dark';
      case 'kbauto':
        return 'row-icon-kbauto';
      default:
        return 'row-icon-light';
    }
  }

  goToRoute(item: any) {
    const url = `/${this.selectedLanguage}/${item.isCustomPage ? '/pages' + item.link : item.link}`
    this.router.navigate([url]);
  }
}
